export default function dashboardDataSelector(func) {
  return func((state) => state.dashboardReducer);
}
